var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.isNewUser)?_c(_setup.CouponGuide,{staticClass:"cross-coupon-guide",attrs:{"dpPageId":_setup.DP_PAGE,"dpPositionId":_setup.MAINLAND_COUPON_GUIDE_POSID,"entry":"北上精选","isShowHeader":false}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }